import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  IconButton,
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'

const Confirmation = ({ open, onClose, onConfirm, message }) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby='delete-confirmation-dialog'
      sx={{
        '& .MuiBackdrop-root': {
          backgroundColor: 'rgba(0, 0, 0, 0.6)',
        },
      }}>
      <DialogTitle
        id='delete-confirmation-dialog'
        sx={{
          backgroundColor: '#FF8A65',
          color: '#000',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '40px',
          width: '570px',
        }}>
        BID - Confirmation
        <IconButton aria-label='close' onClick={onClose} sx={{ color: '#000' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '70px',
        }}>
        <Typography
          variant='body1'
          sx={{ color: '#000', fontSize: '20px', fontWeight: '500' }}>
          {message}
        </Typography>
      </DialogContent>
      <DialogActions
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
        }}>
        <Button
          onClick={onConfirm}
          variant='contained'
          sx={{
            backgroundColor: '#FF7043',
            color: '#FFF',
            borderRadius: '20px',
            width: '112px',
          }}>
          Yes
        </Button>
        <Button
          onClick={onClose}
          sx={{
            backgroundColor: '#C5C5C5',
            color: '#FFF',
            borderRadius: '20px',
            width: '112px',
          }}>
          No
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default Confirmation
